import { getToken } from './tokenStorage';

const jsonFetch = (url, data, init = {}) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const options = {
    method: 'GET',
    credentials: 'omit',
    ...init,
    headers: init.headers || headers,
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  return fetch(url, options).then(r => {
    if (r.ok) {
      const token = getToken();
      if (!token) {
        const authHeader = r.headers.get('Authorization');
        if (!authHeader) {
          return r.json();
        }
        return r.json().then((data = {}) => {
          data.token = authHeader.replace('Bearer ', '');
          return data;
        });
      } else {
        return r.json();
      }
    }
    return r.json().catch(() => Promise.reject({
      status: r.status,
      errors: ['Request JSON error'],
    })).then(json => Promise.reject({
      status: r.status,
      errors: json.errors || [json.error],
    }));
  }).catch(error => {
    if (error instanceof Error) {
      return Promise.reject({ errors: [error.toString()] });
    }
    if (typeof error === 'string' || error instanceof String) {
      return Promise.reject({ errors: [error] });
    }
    if (error && typeof error === 'object' && error.constructor === Object) {

      if (error.status === 401 && (options.method === 'GET')) {
        return;
      }

      return Promise.reject({
        status: error.status,
        errors: error.errors
      });
    }
    return Promise.reject({
      errors: ['Unknown error'],
    });
  });
};

export { jsonFetch };



// WEBPACK FOOTER //
// ./src/utils/fetch.js